import { render } from "./Customize.vue?vue&type=template&id=52b605c1&scoped=true"
import script from "./Customize.vue?vue&type=script&lang=js"
export * from "./Customize.vue?vue&type=script&lang=js"

import "./Customize.vue?vue&type=style&index=0&id=52b605c1&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\wkt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b605c1"]])

export default __exports__